export const noop = (): void => {}

export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined
}

/**
 * Chunk an array into smaller arrays of a specified size
 * @param {Array} array
 * @param {number} size
 * @returns
 */
export const arrayChunks = <T>(array: T[], size: number): T[][] => {
  if (size === 0 || array.length === size) {
    return [array]
  }
  return Array(Math.ceil(array.length / size))
    .fill(undefined)
    .map((_, index) => index * size)
    .map((begin) => array.slice(begin, begin + size))
}

export const generateUniqueHrefs = (length = 0, baseId?: string): Array<{ id: string; href: string }> => {
  return Array.from({ length }, (_, index) => {
    const id = baseId ? `${baseId}_${index}` : `${index}_:r${Math.random().toString(36).substring(2, 9)}:`
    const href = `#${id}`
    return { id, href }
  })
}
